<div class="m-5 mt-0">
  <h3>{{ heading }}</h3>
  <p-table
    #dt
    [value]="items"
    dataKey="id"
    [loading]="loading"
    responsiveLayout="scroll"
    [globalFilterFields]="['name']"
  >
    <ng-template pTemplate="caption">
      <div class="d-flex flex-wrap gap-2 align-items-center justify-content-between">
        <div class="d-flex">
          <p-iconField>
            <p-inputIcon styleClass="pi pi-search" />
            <input id="search" pInputText type="text" (input)="onGlobalFilter($event)" placeholder="Search"
                   class="w-full" [(ngModel)]="search"/>
          </p-iconField>
          <p-button [text]="true" [severity]="'secondary'" icon="pi pi-filter-slash" (click)="clearSearch()"/>
        </div>
        <p-button
          (click)="addItem()"
          pRipple
          [rounded]="true"
          [outlined]="true"
          class="p-button-text"
          icon="pi pi-plus"
          label="Add new"
        ></p-button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        @for (col of columns; track col.title) {
          <th  scope="col" [pSortableColumn]="col.field" class="white-space-nowrap">
            <span>{{ col.title }}</span>
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th scope="col">Enabled</th>
        <th scope="col" class="text-center" style="width: 10rem" >Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        @for (col of columns; track col.title; let first = $first) {
          <td>
            @if (col.template) {
              <ng-container *ngTemplateOutlet="col.template; context: {item: item, field: col.field}"></ng-container>
            } @else {
              <span class="cell-content">
              <span>{{ item[col.field]?.length > maxColCharacters ? (item[col.field] | slice:0:maxColCharacters) + '...': item[col.field] }}</span>
                @if (showDefaultItemBadge && item.default && first) {
                  <p-badge value="Default"></p-badge>
                }
              </span>
            }
          </td>
        }
        <td style="text-align: center">
          <p-inputSwitch (onChange)="toggle.emit(item)" [(ngModel)]="item.enabled" [disabled]="item.id === 0"></p-inputSwitch>
        </td>
        <td style="text-align: center">
          <div>
            <p-button
              (click)="editItem(item)"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              icon="pi pi-pencil"
              pRipple
            />
            <p-button
              (click)="deleteItem(item)"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              icon="pi pi-trash"
              pRipple
            />
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length + 2" class="text-center">No records found</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="deleteItemDialog" [modal]="true" [style]="{width:'450px'}" header="Confirm delete">
  <div class="d-flex align-items-center">
    <i class="pi pi-exclamation-triangle me-3" style="font-size: 2rem"></i>
    <div>
      <span>Delete</span>
      <strong class="ms-1">{{item?.name}}</strong>?
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" label="No" [text]="true" (click)="deleteItemDialog = false"></p-button>
    <p-button icon="pi pi-check" label="Yes" (click)="onDeleteConfirm()"></p-button>
  </ng-template>
</p-dialog>
